import React, { memo, useEffect, useState } from 'react'
import { useAppSelector } from '../../../ReduxTool/store/hooks';
import { countryJsonType } from '../../../ReduxTool/Slice/Auth/types';
import { loadCountryMaster, parseCountryTimezones } from '../../../Utils/countryMaster';
import ReactSelect from '../../../Components/New/Select/ReactSelect';
import { IconInfo } from '../../../assests/icons/DrawerIcons';
import { InputRadio2 } from '../../../Components/AllInput/AllInput';
import { UnitFormState } from './UnitsRegion';

const AUSTRALIAN_TIMEZONES: Record<string, string> = {
  NSW: 'Australia/Sydney',
  'NEW SOUTH WALES': 'Australia/Sydney',
  ACT: 'Australia/Sydney',
  'AUSTRALIAN CAPITAL TERRITORY': 'Australia/Sydney',
  VIC: 'Australia/Melbourne',
  VICTORIA: 'Australia/Melbourne',
  QLD: 'Australia/Brisbane',
  QUEENSLAND: 'Australia/Brisbane',
  SA: 'Australia/Adelaide',
  'SOUTH AUSTRALIA': 'Australia/Adelaide',
  WA: 'Australia/Perth',
  'WESTERN AUSTRALIA': 'Australia/Perth',
  TAS: 'Australia/Hobart',
  TASMANIA: 'Australia/Hobart',
  NT: 'Australia/Darwin',
  'NORTHERN TERRITORY': 'Australia/Darwin',
};

const getAustralianTimezone = (address?: string) => {
  let state = '';
  try {
    const savedAddress = JSON.parse(address || '{}');
    state = typeof savedAddress?.state === 'string' ? savedAddress.state : '';
  } catch {
    // Older addresses were saved as address,city,state,country,pincode.
    state = address?.split(',').slice(-3)[0] || '';
  }
  return AUSTRALIAN_TIMEZONES[state.trim().toUpperCase()] ?? 'Australia/Sydney';
};

type Props = { values: UnitFormState;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

const SettingUnits = ({ units, handleChange }: { units: UnitFormState; handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void }) => {
  const [countries, setCountries] = useState<countryJsonType[]>([]);
  useEffect(() => {
    let mounted = true;
    loadCountryMaster().then(data => { if (mounted) setCountries(data); }).catch(() => {});
    return () => { mounted = false; };
  }, []);
     const UnitsSimple = ({ values, handleChange, disabled = false }: Props) => {

  return (
    <div>
      {/* Measurement System */}
      <div className="main-box1 group relative">
        <label className="label-box1">
          Measurement system{" "} <span className="text-rose-400 text-lg pl-0.5">*</span>
        </label>
        <div className="input-main2">
          <InputRadio2  disabled={disabled}   name="measurementSystem" value={values.measurementSystem}  onChange={handleChange}
            options={[ { label: "Metric (meters, sq. meters)",value: "Metric",   },  {label: "Imperial (feet, sq. feet)", value: "Imperial",  },   ]}  />
        </div>
      </div>

      {/* Energy Unit */}
      <div className="main-box1 group relative">
        <label className="label-box1">
          Energy unit{" "} <span className="text-rose-400 text-lg pl-0.5">*</span>
        </label>
        <div className="input-main2">
          <InputRadio2 disabled={disabled} name="energyUnit" value={values.energyUnit} onChange={handleChange}
             options={[  { label: "kWh (kilowatt-hour)",  value: "kWh",  }, {  label: "MWh (megawatt-hour)",   value: "MWh",   },    ]}  />
        </div>
      </div>

      {/* Time Format */}
      <div className="main-box1 group relative">
        <label className="label-box1">
          Time format{" "} <span className="text-rose-400 text-lg pl-0.5">*</span>
        </label>
        <div className="input-main2">
          <InputRadio2 disabled={disabled} name="timeFormat" value={values.timeFormat} onChange={handleChange}
           options={[  {label: "12-hour (AM/PM)",value: "12h", },
              { label: "24-hour",  value: "24h", },     ]} />
        </div>
      </div>
    </div>
  );
};

const {user} = useAppSelector(state=>state.auth)
    
  
    const country = countries.find(item => item.countryid === user.countryid ||
      item.alpha2code === user.country_mstr?.alpha2code) ?? user.country_mstr;
    const currencyCode = country?.currencycode?.trim().toUpperCase();
    const selectedCurrencyValue = currencyCode
      ? `${country?.countryname} (${currencyCode})`
      : 'Currency unavailable';
    const zones = parseCountryTimezones(country?.timezones);
    const preferredZone = country?.alpha2code === 'AU' ? getAustralianTimezone(user.address) :
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    const selectedZone = zones.find(zone => zone.zoneName === preferredZone) ?? zones[0];
    const timezone = selectedZone
      ? `${selectedZone.gmtOffsetName ? `${selectedZone.gmtOffsetName} ` : ''}${selectedZone.zoneName}`
      : 'Timezone unavailable';
    const timezoneOption = { label: timezone, value: timezone };
    const currencyOption = { label: selectedCurrencyValue, value: selectedCurrencyValue };

  return (
    <>
    <div className="flex flex-col w-full h-full p-1">

        <div className="subHeadingSection">
            <span className=' text-roboto-14-roboto-400-gray '>Choose how measurements and energy values appear across your solar dashboard.</span>
        </div>

        <div className="unitsRadioSelectSection">
          <UnitsSimple values={units} handleChange={handleChange} disabled={true} />
        </div>
        
        <div className="unitstypereactselectsection">
        <div>
            <ReactSelect handleInputChange={()=>{}} options={[timezoneOption]} onChange={()=>{}} value={timezoneOption} id={"timezone"} name={"timezone"} labelname="Timezone" closeMenuOnSelect={true} isUpload={false} isrequired={true} icon={<IconInfo />} disabled={true} />
        </div>
        <div>
            <ReactSelect handleInputChange={()=>{}} options={[currencyOption]} onChange={()=>{}} value={currencyOption} id={"currency"} name={"currency"} labelname="Currency" closeMenuOnSelect={true} isUpload={false} isrequired={true} icon={<IconInfo />} disabled={true} />
        </div>
        </div>
    </div>
  </>
  )
}



export default memo(SettingUnits)
